import React from 'react';
import Skeleton from '@mui/material/Skeleton';

const TransactionDetailsSkeleton = () => {
    const divs = Array.from({ length: 3 }, (_, index) => (
        <div className="my-2" key={index}>
            <Skeleton variant="rectangular" width={'100%'} height={50} />
        </div>
    ));

    return (
        <div className="my-4">
            <div className="row my-1">
                <div className="col-5"></div>
                <div className="col-2">
                    <Skeleton variant="rectangular" width={'100%'} height={30} />
                </div>
                <div className="col-5"></div>
            </div>
            <div className="row my-1">
                <div className="col-3"></div>
                <div className="col-6">
                    <Skeleton variant="rectangular" width={'100%'} height={30} />
                </div>
                <div className="col-3"></div>
            </div>
            <div className="row my-1">
                <div className="col-4"></div>
                <div className="col-4">
                    <Skeleton variant="rectangular" width={'100%'} height={30} />
                </div>
                <div className="col-4"></div>
            </div>
            <div className="mt-4">
                {divs}
            </div>
        </div>
    );
}

export default TransactionDetailsSkeleton;